let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dICga")).then(() => parcelRequire('5Kre9'));